import { makeAutoObservable } from "mobx";
import RmaPageStore from "./rma-page-store";
import rmaPagedListStore from "../../rma-list-page/stores/rma-paged-list-store";
import RmaListItemStore from "../../rma-list-page/stores/rma-item-store";
import { APP_PATHS } from "../../../../constants/app-paths";
import { IIframeService } from "../../../../services/iframe-service/iframe-service";
import { TYPE, rootContainer } from "../../../../services/container/root";

function isIndexInArray(index:number, arr:object[]): boolean {
	if (index < 0) {
		return false;
	}
	return index >= 0 && index <= arr.length - 1;
}

export class RmaPageMainStore {
	private _currentRmaPageStore?: RmaPageStore;
	private _mapOfUpdatedRmas: { [rmaId: number]: boolean } = {};
	/** Set by redesign list store — avoids circular import with rma-tabs-paged-list-store. */
	private _redesignNavigationListProvider: (() => RmaListItemStore[]) | null = null;

    constructor() {
		makeAutoObservable(this, {}, { autoBind: true });
	}

	public setRedesignNavigationListProvider(provider: () => RmaListItemStore[]): void {
		this._redesignNavigationListProvider = provider;
	}

	private get iframeService(): IIframeService {
		return rootContainer.get<IIframeService>(TYPE.IframService);
	}

	public setRmaPageStore(rmaId: number): void {
		if (this._currentRmaPageStore?.rmaId !== rmaId) {
			this._currentRmaPageStore = new RmaPageStore(this, rmaId);
			this._currentRmaPageStore.loadRma();
		}
		this.iframeService.navigateReturns({ rmaid: rmaId });
	}

	public getRmaPageStore(): RmaPageStore|undefined {
		return this._currentRmaPageStore;
	}

	public getUpdatedRmas(): number[] {
		return (Object.keys(this._mapOfUpdatedRmas) as unknown) as number[];
	}

	public addUpdatedRmaId(rmaId: number): void {
		this._mapOfUpdatedRmas[rmaId] = true;
	}

	public clearUpdatedRmaIds(): void {
		this._mapOfUpdatedRmas = {};
	}

	/** Redesign list lives in a separate paged store; prev/next must follow the active route tree. */
	private _getNavigationList(): RmaListItemStore[] {
		if (window.location.pathname.startsWith(APP_PATHS.RETURNS_NEW)) {
			return this._redesignNavigationListProvider?.() ?? [];
		}
		return rmaPagedListStore.list;
	}

	public get nextRmaId(): undefined|number {
		const list = this._getNavigationList();
		const foundIndex = list.findIndex(i => i.rmaId === this._currentRmaPageStore?.rmaId);
        if (foundIndex === -1) {
            return undefined;
        }
        const nextIndex = foundIndex + 1;
		return isIndexInArray(nextIndex, list) ? list[nextIndex].rmaId : undefined;
	}

	public get prevRmaId(): undefined|number {
		const list = this._getNavigationList();
		const foundIndex = list.findIndex(i => i.rmaId === this._currentRmaPageStore?.rmaId);
        if (foundIndex === -1) {
            return undefined;
        }
		const prevIndex = foundIndex - 1;
		return isIndexInArray(prevIndex, list) ? list[prevIndex].rmaId : undefined;
	}
    
}
export default new RmaPageMainStore();
